import React from 'react';

function Rules() {
  return (
    <div className="container py-4">
      <div className="card mx-auto shadow-sm" style={{maxWidth: 900}}>
        <div className="card-body">
          <h2 className="card-title mb-4">Pravidla Posázavské ligy</h2>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Hrajeme s respektem k soupeři, bez zákeřností, se správnýma emocema.</li>
            <li className="list-group-item">Věk hráčů 35+, výjimku tvoří brankář, který může být mladší.</li>
            <li className="list-group-item">Doba hry je 2 x 40 minut, lze domluvit i 2 x 35 v horkém počasí.</li>
            <li className="list-group-item">Hraje se jedenáct na jedenáct na celé hřiště.</li>
            <li className="list-group-item">Skluzy v blízkosti soupeře jsou zakázány. Pokud skluz přijde, je to faul.</li>
            <li className="list-group-item">Domácí zajistí pro utkání rozhodčího, který je registrovaný FAČRem a píská soutěž.</li>
            <li className="list-group-item">Startovné do soutěže je 2000,- a peníze se zasílají do 15.4. na účet 7931380699/6363.</li>
            <li className="list-group-item">Domácí tým nahlásí, po konci utkání, výsledek do skupiny PLSG včetně poločasového stavu.</li>
            <li className="list-group-item">V případě, že se tým není schopen sejít a odehrát zápas, následuje omluva soupeři nejpozději do čtvrtka před zápasem. Utkání se kontumuje 3:0 a zašle se 1000,- na účet 7931380699/6363.</li>
            <li className="list-group-item">Budu rád když z utkání vzniknou nějaké fotografie pro instagram posázavské ligy.</li>
            <li className="list-group-item">
              <strong>Pořadí v tabulce:</strong> Rozhoduje celkový počet bodů
              (3 za výhru, 1 za remízu, 0 za prohru). Při rovnosti bodů rozhodují postupně:
              <ol className="mt-2 mb-2">
                <li>Body ze vzájemných zápasů týmů se shodným celkovým počtem bodů.</li>
                <li>Celkový rozdíl vstřelených a obdržených branek ve všech zápasech sezóny.</li>
                <li>Celkový počet vstřelených branek ve všech zápasech sezóny.</li>
              </ol>
              Při shodě tří a více týmů se použije minitabulka všech jejich vzájemných zápasů.
              Pokud ani body v minitabulce nerozhodnou, pokračuje se celkovým rozdílem skóre
              a počtem vstřelených branek; minitabulka se pro menší podskupiny nepřepočítává.
              Započítávají se pouze zápasy se zadaným konečným výsledkem.
              Pokud jsou všechna kritéria shodná, pravidla mezi týmy dále nerozhodují.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Rules;
